import { useState } from 'react';
import { password, sameAsField, maxPostCode } from './validators';

const useForm = (data = {}, rules = {}) => {
    const [state, setState] = useState({ data, fieldsErrors: {}, errors: null });

    const handleChange = ({ target: { name, value, type, checked } }) => setState(state => ({
        ...state,
        data: { ...state.data, [name]: type === 'checkbox' ? checked : value }
    }));

    const  validateData = () => {
        const fieldsErrors = {};

        Object.keys(rules).forEach(key => {
            const field = state.data[key];
            const { isRequired, validator, ...props } = rules[key];

            if (isRequired && !field) {
                fieldsErrors[key] = 'Is required';
            } else if (typeof validator === 'function') {
                fieldsErrors[key] = validator(field, props, state.data);
            } else {
                fieldsErrors[key] = null;
            }
        });

        setState(state => ({ ...state, fieldsErrors }));

        return Object.values(fieldsErrors).every(e => !e);
    };

    const setErrors = errors => setState(state => ({ ...state, errors }));

    const resetForm = () => setState({ data, fieldsErrors: {}, errors: null });

    const setFormValues = values => setState(state => ({ ...state, ...values }));

    return {
        ...state,
        handleChange,
        validateData,
        setErrors,
        resetForm,
        setFormValues,
    };
};
export const FORM_VALIDATORS = {
    password,
    sameAsField,
    maxPostCode,
};

export default useForm;
